import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { PreparationTime } from 'src/app/shared/models/quota/preparation-time';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class CenterService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Récupère la liste des centres
	 * @returns
	 */
	getAllCenter(): Observable<ServiceCenter[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerUrl}`,
			'getAllCenter'
		);
	}

	/**
	 * Récupère un centre en fonction de son id
	 * @param id id du centre
	 * @returns
	 */
	getCenterById(id: number): Observable<ServiceCenter> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerUrl}/${id}`,
			'getCenterById'
		);
	}

	/**
	 * Renvois la liste des centres visible par l'utilisateur
	 * @returns
	 */
	getAllViewableCenter(): Observable<ServiceCenter[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerUrl}/viewable`,
			'getAllViewableCenter'
		);
	}

	getPreparationTimeForCenter(): Observable<PreparationTime[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.centerUrl}/preparationTime`,
			'getPreparationTimeForCenter'
		);
	}
}
